
/**
 * Space to organise key names/values and some logic for persistent data
 * used on forms
 */
export default {
    /**
     * A map of form field names from the Vue side to what to store them as
     * in the cookie store for persistence.
     *
     * Vue field on left as the key, cookie name on right as value
     * 
     * The main key of the `storeableKeys` object is for re-use, see the get method
     */
    storeableKeys: {
        employerInformation: {
            employerName: 'employer-company-name'
        },
        employerEmailInformation: {
            jobTitle: 'employer-job-title',
            jobLocation: 'employer-job-location',
            employmentType: 'employer-employment-type',
            enquiry: 'employer-enquiry',
            emailAddress: 'employer-email-address',
            companyName: 'employer-company-name',
            contactName: 'employer-contact-name',
            telephoneNumber: 'employer-telephone-number',
        },
        sharedTelFaxWebSiteInformation: {
            firstName: 'candidate-first-name',
            surname: 'candidate-surname',
            jobTitle: 'candidate-job-title',
            emailAddress: 'candidate-email-address',
            telephoneNumber: 'candidate-telephone-number',
            employerName: 'employer-company-name',
        },
        candidateTelFaxWebSiteInformation: {
            firstName: 'candidate-first-name',
            surname: 'candidate-surname',
            jobTitle: 'candidate-job-title',
            emailAddress: 'candidate-email-address',
            telephoneNumber: 'candidate-telephone-number',
        },
        candidateEmailInformation: {
            preferredJobRole: 'candidate-preferred-jobrole',
            preferredLocation: 'candidate-preferred-location',
            salaryExpectationUnit: 'candidate-salary-expectation-unit',
            salaryExpectationValue: 'candidate-salary-expectation-value',
            enquiry: 'candidate-enquiry',
            firstName: 'candidate-first-name',
            surname: 'candidate-surname',
            jobTitle: 'candidate-job-title',
            emailAddress: 'candidate-email-address',
            telephoneNumber: 'candidate-telephone-number',
        }
    },

    getKeysForForm(formName) {
        console.log(`Getting persistence data for ${formName}`);
        switch (formName) {
            case 'contactFormBranchSelect':
                return this.storeableKeys.sharedTelFaxWebSiteInformation;
            case 'CandidateInformation':
                return this.storeableKeys.candidateTelFaxWebSiteInformation;
            case 'contactFormWebsiteSuccess':
            case 'contactFormTelFaxSuccess':
            case 'EmployerInformation':
                return this.storeableKeys.employerInformation;
            case 'EmailCandidate':
                return this.storeableKeys.candidateEmailInformation;
            case 'EmailEmployerEnquiry':
            case 'EmailEmployerCallback':
                return this.storeableKeys.employerEmailInformation;
            default:
                console.log('>> Issue: unknown form to provide storage data <<');
                return {};
                //throw new Error(`Unknown form ${formName}`);
        }
    }

}
